export const DEFAULT_DOUYIN_CREATOR_TEST_CART_LINK = 'https://haohuo.jinritemai.com/ecommerce/trade/detail/index.html?id=3652996615809139745&origin_type=604';
